<template>

  <v-card class="elevation-7 print-card" :class="{'mobile-card': $vuetify.breakpoint.xsOnly}">
    <v-toolbar class="toolbar3 white--text">
      <v-toolbar-title>Valores Pagos à Serventia</v-toolbar-title>
    </v-toolbar>
    <v-divider light></v-divider>
    <v-layout align-start row wrap fill-height class="remove-space-on-print">

      <v-flex xs4 :class="{'pb-0 pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div>Emolumentos:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.emolumento}}</b></div>

            <div>Custas FUNDIMPER:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.fundimper}}</b></div>

          </div>
        </v-card-title>
      </v-flex>

      <v-flex xs4 :class="{'pb-0 pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div>Custas FUMORPGE:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.fumorpge}}</b></div>

            <div>Custas FUJU:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.fuju}}</b></div>
          </div>
        </v-card-title>
      </v-flex>

      <v-flex xs4 :class="{'pb-0 pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>

            <div>Custas FUNDEP:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.fundep}}</b></div>

            <div>Selo:</div>
            <div><b :class="$vuetify.breakpoint.name">R$ {{valor.selo}}</b></div>

          </div>
        </v-card-title>
      </v-flex>

      <v-flex xs12 pt-0>
        <v-card-title class="fix-margin-print">
          <div>
            <div class="inline">Total:</div>
            <div class="inline"><b :class="$vuetify.breakpoint.name">R$ {{valor.total}}</b></div>
          </div>
        </v-card-title>
      </v-flex>

    </v-layout>
  </v-card>
</template>

<script>
  import ValorSeloAto from "../../domain/selo/valor-selo-ato";

  export default {
    name: "ValorPagoServentiaCard",
    props: {
      valor: {
        type: ValorSeloAto,
        required: true
      }
    },
    data: function () {
      return {};
    }
  }
</script>

<style scoped>
  /*.xs6 > .fix-margin-print,*/
  /*.xs6 > .fix-margin-print {*/
  /*margin: 0;*/
  /*padding: 16px;*/
  /*}*/

  /*.fix-margin-print {*/
  /*margin: 0;*/
  /*padding: 0;*/
  /*}*/

  .toolbar3 {
    background: #4C67FF;
  }

  .inline {
    display: inline;
  }

</style>



// WEBPACK FOOTER //
// src/components/detalhes/ValorPagoServentiaCard.vue